module.exports = __webpack_public_path__ + "images/apps/api-87c68301e1f2a74e8fbedaa4862fd469.png";